// extracted by mini-css-extract-plugin
module.exports = {"section-title":"SectionTitle_section-title__1uBgo","title":"SectionTitle_title__Ix0Om","sub-title":"SectionTitle_sub-title__3czzE"};